import { render, staticRenderFns } from "./CarTrajectory.vue?vue&type=template&id=3b12b935&scoped=true&"
import script from "./CarTrajectory.vue?vue&type=script&lang=js&"
export * from "./CarTrajectory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b12b935",
  null
  
)

export default component.exports